/**
 * How a connector definition's egress allow-list reads (#992): how many hosts it may reach, or
 * Unrestricted when it declares none. The Connectors list and the connector panel say it alike.
 */
export function egressCellText(hostCount: number): string {
  if (hostCount === 0) return "Unrestricted";
  return hostCount === 1 ? "1 host" : `${hostCount} hosts`;
}

/** The panel's line: the count, then the names, or the unrestricted explanation. */
export function egressDetailText(hosts: readonly string[]): string {
  return hosts.length === 0
    ? "Unrestricted: this definition declares no hosts"
    : `${egressCellText(hosts.length)}: ${hosts.join(", ")}`;
}
